import { Amplify } from 'aws-amplify';

const awsConfig = {
    API: {
        endpoints: [
            {
                name: "PingDomStatusDataURL",
                endpoint: process.env.REACT_APP_PingDomStatus_Data_Endpoint
            },
        ]
    },
    Auth: {
        region: process.env.REACT_APP_COGNITO_REGION,
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
        mandatorySignIn: true,
        oauth: {
            domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
            scope: [
                "email",
                "openid",
                "profile",
                "aws.cognito.signin.user.admin"
            ],
            redirectSignIn: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN,
            redirectSignOut: process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT,
            responseType: process.env.REACT_APP_COGNITO_RESPONSE_TYPE // e.g. 'code'
        }
    }
};

export function configureAmplify() {

    Amplify.configure(awsConfig)

}